<template>
  <v-dialog :value="true" persistent scrollable :fullscreen="true">
    <v-card>
      <v-card-title class="text-h3 primary--text"
        >CALENDARIO DE RESPONSABLES DE MUESTRA</v-card-title
      >
      <v-card-text>
        <v-layout row class="mt-1">
          <v-flex xs12>
            <v-autocomplete
              clearable
              v-model="enfermera"
              @change="enfermeraCambiada"
              outlined
              label="Responsable de Muestra"
              :items="enfermeras"
              item-text="Nombre"
              item-value="UsuarioID"
            >
            </v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout row class="mt-1">
          <v-flex xs8>
            <v-layout row class="ma-3">
              <v-flex xs2>
                <v-btn icon class="ma-2" @click="$refs.calendar.prev()">
                  <v-icon>mdi-chevron-left</v-icon></v-btn
                >
              </v-flex>
              <v-flex xs8 class="text-center text-h3 primary--text">
                {{ titulo }}
              </v-flex>
              <v-flex xs2 class="text-right">
                <v-btn icon class="ma-2" @click="$refs.calendar.next()">
                  <v-icon>mdi-chevron-right</v-icon></v-btn
                >
              </v-flex>
            </v-layout>
            <v-sheet height="60vh">
              <v-calendar
                :event-height="13"
                @click:date="mostrarDia"
                :events="events"
                @click:event="verDiaEnfermera"
                @change="getEvents"
                v-model="value"
                locale="es-es"
                ref="calendar"
                type="month"
              >
                <template v-slot:event="{ event }">
                  <div class="ml-2 chica">{{ event.name }}</div>
                </template>
              </v-calendar>
            </v-sheet>
          </v-flex>
          <v-flex xs4>
            <v-sheet height="70vh">
              <v-calendar
                @change="getCitasDia"
                :value="dia"
                :events="eventsDia"
                first-time="6"
                interval-minutes="60"
                locale="es-es"
                type="day"
                event-color="primary"
              >
                <template v-slot:event="{ event }">
                  <span class="ml-2 ">{{ event.name }}</span>
                </template>
              </v-calendar>
            </v-sheet>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <span class="ma-2">
          RESPONSABLES DE MUESTRA:
          <v-chip
            class="ml-2 mr-2 white--text"
            v-for="e in enfermeras"
            :color="e.Color"
            :key="e.UsuarioID"
          >
            {{ e.Iniciales }}
          </v-chip>
        </span>
        <v-spacer> </v-spacer>

        <v-btn class="mr-5" text @click.prevent="cerrar"> Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ServicioCitas from "../../services/citas";
export default {
  name: "calendarioEnfermeras",
  data() {
    return {
      value: "",
      meses: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      events: [],
      dia: "",
      eventsDia: [],
      enfermeras: [],
      start: "",
      end: "",
      startDia: "",
      enfermera: null,
      tmpEnfermera: null,
    };
  },
  mounted() {
    this.value = this.fechaPicker(this.hoy);
  },
  methods: {
    async enfermeraCambiada() {
      await this.getEvents({ start: this.start, end: this.end });
      await this.getCitasDia({ start: this.startDia });
    },
    async getCitasDia({ start }) {
      this.startDia = start;
      const enfermeraID = this.tmpEnfermera ?? this.enfermera ?? 0;
      const resHoras = await ServicioCitas.getHorasCitas(
        start.date,
        enfermeraID
      );
      this.tmpEnfermera = null;
      const tablaHoras = resHoras.data.data.Table0;
      let events = [];
      for (let i = 5; i <= 20; i++) {
        const c = tablaHoras.filter((obj) => obj.Hora === i && obj.Citas > 0);
        c.forEach((obj) => {
          const hora = i > 9 ? String(i) : `0${i}`;
          const estart = new Date(`${start.date}T${hora}:00:00`);
          const eend = new Date(`${start.date}T${hora}:59:59`);
          let name = `${obj.Citas} cita${obj.Citas > 1 ? "s" : ""}`;
          if (obj.CitasUsuario > 0) {
            name += ` (${obj.CitasUsuario} asignadas)`;
          }
          events.push({
            name,
            start: estart,
            end: eend,
            color: obj.Color,
            timed: true,
            category: obj.Iniciales,
            Enfermera_UsuarioID: obj.Enfermera_UsuarioID,
          });
        });
      }
      this.eventsDia = events;
    },
    async verDiaEnfermera(ev) {
      this.tmpEnfermera = ev.event.Enfermera_UsuarioID;
      if (this.dia !== ev.event.start) {
        this.dia = ev.event.start;
      } else {
        await this.getCitasDia({
          start: this.startDia,
        });
      }
    },
    mostrarDia(e) {
      if (this.dia !== e.date) this.dia = e.date;
      else {
        this.getCitasDia({ start: this.startDia });
      }
    },
    async getEvents({ start, end }) {
      this.start = start;
      this.end = end;
      const events = [];

      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
      const enfermeraID = this.enfermera ?? 0;
      const res = await ServicioCitas.getCitasFecha(min, max, enfermeraID);

      if (res.data.result === 1) {
        const data = res.data.data.Table0;
        this.enfermeras = res.data.data.Table1;
        const grupos = [];
        data.forEach((c) => {
          const grupo = grupos.find(
            (g) =>
              c.FechaMuestra.split("T")[0] === g.Fecha &&
              g.Enfermera_UsuarioID === c.Enfermera_UsuarioID
          );
          if (grupo) {
            grupo.NumeroCitas++;
          } else {
            grupos.push({
              Fecha: c.FechaMuestra.split("T")[0],
              Enfermera_UsuarioID: c.Enfermera_UsuarioID,
              NumeroCitas: 1,
              Color: c.Color,
            });
          }
        });
        grupos.forEach((g) => {
          events.push({
            name: g.NumeroCitas + " citas",
            start: g.Fecha,
            end: g.Fecha,
            color: g.Color,
            timed: false,
            Enfermera_UsuarioID: g.Enfermera_UsuarioID,
          });
        });
      } else {
        this.$root.mensajeError = res.data.message;
      }

      this.events = events;
    },
    cerrar() {
      this.$emit("cerrar");
    },
  },
  computed: {
    titulo() {
      if (!this.value) {
        return "";
      }
      const parts = this.value.split("-");
      return this.meses[parseInt(parts[1]) - 1] + " " + parts[0];
    },
  },
};
</script>

<style scoped>
.chica {
  margin-top: -3px;
  font-size: 10px;
}
</style>
